import AudioVisualizer from './AudioVisualizer';

export default AudioVisualizer;
